import {
  StyleSheet,
  Modal,
  View,
  Text,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from "react-native";
import React from "react";
import * as Animatable from "react-native-animatable";
import color from "@constants/color";
import RadioButton from "@components/RadioButton";
import PressableButton from "@components/PrimaryButton";
import t from "@constants/localization";
import { s } from "@utils/metrics_1";
import Cross from "@assets/svg/CrossIcon";

const FraudModal = ({
  showFraudModal,
  setShowFraudModal,
  fraudInfo,
  onPress = () => {},
  isLoading,
  fraudReason,
  setFraudReason = () => {},
}) => {
  const PATH = "screens/CustomerProfile/FraudModal";
  const { title = "", reasons = [] } = fraudInfo || {};
  const setSelectedOption = (key) => {
    setFraudReason(key);
  };

  const onClose = () => {
    setFraudReason("");
    setShowFraudModal(false);
  };

  return (
    <Animatable.View
      animation="fadeInUp"
      duration={300}
      useNativeDriver={true}
      delay={0}
    >
      <Modal
        animationType="fade"
        transparent={true}
        visible={showFraudModal}
        onRequestClose={onClose}
      >
        <View style={styles.modalBackground} />
        <TouchableWithoutFeedback onPress={onClose}>
          <View style={styles.modalBackground} />
        </TouchableWithoutFeedback>
        <View style={styles.container}>
          <View style={styles.headingContainer}>
            <Text style={styles.modalText}>{title}</Text>
            <TouchableOpacity
              testID="cfm-close-btn"
              onPress={onClose}
              style={styles.closeButton}
            >
              <Cross width={25} height={25} />
            </TouchableOpacity>
          </View>

          <RadioButton
            radioOptions={reasons}
            setSelectedOption={setSelectedOption}
            labelColor={color.mediumBlack}
            radioColor={color.primary}
            radionButtonContainerStyle={styles.radioButtonContainerStyle}
          />
          <View
            style={{
              margin: 10,
            }}
          >
            <PressableButton
              text={t(`${PATH}/submit`)}
              textStyle={styles.submitButtontext}
              onPress={onPress}
              loading={isLoading}
              disabled={fraudReason === ""}
            />
          </View>
        </View>
      </Modal>
    </Animatable.View>
  );
};

export default FraudModal;

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    width: "100%",
  },
  modalText: {
    color: "black",
    fontSize: 20,
    fontWeight: "700",
  },
  modalBackground: {
    flex: 1,
    backgroundColor: color.mediumBlacklightBlack,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  radioButtonContainerStyle: {
    marginTop: s.l,
  },
  submitButtontext: {
    fontSize: 14,
    fontWeight: "700",
  },
  headingContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: s.l,
    paddingTop: 20,
  },
});
